/**
 * Thin app shell for routine HITL — Icon + flag/auth read gate cross here;
 * parsing, diffs, and the custom card live behind `@heidi/agents`.
 */
import { useIsWorkflowsEnabled } from '@/features/flags';
import { RoutineApprovalCard, type RoutineApprovalCardProps } from '@heidi/agents';
import { useIsAuthenticated } from '@heidi/agents/data';
import { Routines } from '@heidi/design-system/icons';
import type { LucideIcon } from 'lucide-react';

type CreateWorkflowApprovalCardProps = Pick<
  RoutineApprovalCardProps,
  'approval' | 'onResolve'
>;

export function CreateWorkflowApprovalCard({
  approval,
  onResolve,
}: CreateWorkflowApprovalCardProps): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const routinesReadEnabled = useIsWorkflowsEnabled() && isAuthenticated;
  return (
    <RoutineApprovalCard
      approval={approval}
      onResolve={onResolve}
      Icon={Routines as LucideIcon}
      routinesReadEnabled={routinesReadEnabled}
    />
  );
}
